import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import {coleccion_cotizaciones,_firestore, customAuth,Coleccion_cotizacion_provedores, numeracion_de_documentos} from '@/FirebaseConfig'
import {secondsToFullTimestamp, a_date} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        datos:{
          documento:'',
          titulo:'Solicitud de Cotización',
          mensaje:`Buenos días,
          En esta oportunidad necesitamos la siguiente lista de productos y agradecemos que pueda presentar una cotización con el fin de poder evaluarla.`,
          provedores:[],
          proveedor_seleccionado:[],
          items:[],
          creado_el:'',
          proveedor:{
            correo_adicional:'',
          },
        },
        interfaz_proveedores:[],
        registro:{},
        lista_de_compras: [],
        registro_de_propuestas:{},
        selectedKey:'',
        dialog_requerimiento:false,
        dialog_cotizaciones: false,
        propuestas_dialog: false,
      },
      mutations: {
        
        
        clean(state,key){
          Vue.delete(state.registro,key)
        }
      },
      actions: {
        getAll:({state})=>coleccion_cotizaciones.onSnapshot( ({docs}) => {
          const registro = []
          docs.map( item => registro.push({...item.data(), id: item.id, creado_el: a_date(item.data().creado_el)}) )
          state.registro = registro
        }),
        add:async ({state,commit,dispatch})=>{
          
          if(state.selectedKey==''){
            
            let numeracion_actual = await numeracion_de_documentos.collection('Cotizacion').doc('00').get()
            let nueva_numeracion = ( numeracion_actual.exists ) ? numeracion_actual.data().numeración + 1 : 1            
            let datos_a_grabar ={
              ...state.datos,
              estado_de_proceso:'procesado',
              estado_de_cotizacion:'esperando',
              creado_el:new Date,
              creado_por:customAuth.currentUser.displayName,
              numero_de_cotizacion:nueva_numeracion,
              igv:0, 
              items: state.datos.items.map(item=>({
                ...item,
                valor_unitario: item.incluye_igv ?  Number(Number(Number(item.valor_unitario)/1.18).toFixed(2)) : Number(item.valor_unitario), cantidad: Number(item.cantidad) ,
                tipo_de_igv : 1 ,
                descuento:0,
                subtotal:0,
                total:0,
                key:item.key,
              })),
              valor_de_venta:0 ,
              total:0,
              estado_del_documento: 'esperando',
            }
            try{
              let idCotizacion = await coleccion_cotizaciones.add(datos_a_grabar)
              state.datos.provedores.map(item=>Coleccion_cotizacion_provedores.doc(item.key).collection('registro').doc(idCotizacion.id).set(datos_a_grabar) )
              let test = await numeracion_de_documentos.collection('Cotizacion').doc('00').update({numeración: _firestore.FieldValue.increment(1)}) 
              console.log(test)
              commit('Helpers/launchSnackbar', 'Se ha enviado una  cotización correctamente', { root: true })
            } catch (error){
              commit('Helpers/launchSnackbar', `Ha ocurrido un error ${error}`, { root: true })
            
              console.log(error)
            }
            state.loading = false 
            await Promise.all( state.datos.items.map(({id_requerimiento} )=> {
              if(id_requerimiento) dispatch('Requerimientos/borrar_requerimiento_por_id',id_requerimiento,{root: true})
            }) )
            dispatch('clearForm')
            dispatch('Requerimientos/clearForm','',{root: true})
              state.selectedKey = ''
              state.dialog_requerimientos = false
          }else{
            coleccion_cotizaciones.doc(state.selectedKey).update(state.datos).then(()=>{
              commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              dispatch('clearForm')
              state.dialog_requerimientos = false
            })
          }
        },
        clean:(context, key)=>{
            coleccion_cotizaciones.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get: async ({state}, key)=>{
            let doc = await coleccion_cotizaciones.doc(key).get()
            state.datos = ({...doc.data(), proveedor:{}})
            state.selectedKey = key
            state.dialog_requerimiento = true
        },
        //HERE IS THE BUG!!!!!!!!!!!!!!!!!!!!
        get_datos: async ({state}, key)=>{
          let doc = await coleccion_cotizaciones.doc(key).get()
          state.datos = ({...doc.data(),creado_el:secondsToFullTimestamp(doc.data().creado_el), proveedor:{}, idCotizacion: doc.id})
          state.selectedKey = key
        },
        obtener_cotizacions_por_proveedor:async ({state},key)=>{
          let doc = await Coleccion_cotizacion_provedores.doc(key).collection('registro').get()
          state.interfaz_proveedores = ([...doc.docs.map(item=>({...item.data(), key: item.id, creado_el: a_date(item.data().creado_el)}))])
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.datos = {
            documento:'',
            titulo:'Solicitud de Cotización',
            mensaje:`Hemos implementado un sistema de cotización en línea que nos permitirá agilizar nuestro proceso de adquisición. En esta oportunidad necesitamos la siguiente lista de productos y agradecemos que pueda presentar una cotización por este medio con el fin de poder evaluarla de forma oportuna.`,
            provedores: [],
            items:[],
            creado_el:'',
            cantidad:'',
          }
        },
        process:async (context, {id, host}) => {
          coleccion_cotizaciones.doc(id).update({estado_del_documento: 'procesando'})
          let credenciales = context.rootState.Credenciales.record
          let nombre_de_db = context.rootState.Customers.data.name
          credenciales = Object.keys(credenciales).map(item=>credenciales[item])
          let function_host = credenciales.filter(item=>item.slug == "credenciales-para-envio")[0].valores
          function_host = function_host.filter(item=>item.descripcion=="functions")[0].valor
          if(!function_host)return context.commit('Helpers/launchSnackbar', 'No existe un hosting de envio de correo' , { root: true })
          let url =`${function_host}?idCotizacion=${id}&host=${host}&base_de_datos=${nombre_de_db}`
          fetch(url).then(res=>context.commit('Helpers/launchSnackbar', 'Se ha realizado en envío de correos' , { root: true }))
        },
        enviar_cotizacion:(context,datos)=>{
          Coleccion_cotizacion_provedores.doc(datos.idProveedor).collection('registro').doc(datos.idCotizacion).update({estado_de_cotizacion: 'cotizado'})
          let proveedor = context.state.datos.provedores.filter(item=>item.key == datos.idProveedor)[0]
          coleccion_cotizaciones.doc(datos.idCotizacion).collection('propuestas').doc(datos.idProveedor).set({ 
            ...context.state.datos,
            creado_el:new Date,
            estado_de_cotizacion:'cotizado',
            proveedor: ({
              ...context.state.datos.proveedor,
              ...proveedor
            })
          }).then(()=>{
            router.push({name:'proveedor_cotizacion', params: {idProveedor:datos.idProveedor, customerName: datos.customerName}})
            context.commit('Helpers/launchSnackbar', 'Se ha registrado una nueva cotización correctamente', { root: true })
          })

        },
        ver_propuestas: async ({state, dispatch },key) => {
          try{
            dispatch('get_datos', key)
            const datos = await coleccion_cotizaciones.doc(key).collection('propuestas').get()
            state.registro_de_propuestas = datos.docs.map( item => ({...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} ) ) 
          } catch (error ){
            console.log(error)
          }
        },
      
        obtener_datos_proveedores: async ({commit}, {id})=>{
          try{
            commit('Helpers/launchSnackbar', 'Obteniendo datos' , { root: true })
            let doc = await coleccion_cotizaciones.doc(id).get()
            return doc

          } catch( error) {
            console.log(error)
            commit('Helpers/launchSnackbar', 'Ha ocurrido un error' , { root: true })
          }

        }
      }, 
      getters: {
        registro: state => Object.keys(state.registro).map(item => ({...state.registro[item], key: item }) ),
        proveedores_de_propuesta: state => { 
          return state.registro_de_propuestas
        },
        propuestas: state => {
            
          const registro_de_propuestas = Object.keys(state.registro_de_propuestas).map(item=> ({...state.registro_de_propuestas[item], key: item, proveedor_documento:state.registro_de_propuestas[item].proveedor.document  }) )
          let salida = []
          salida = state.datos.items.map(item => {   
            registro_de_propuestas
              .map(lista => lista.items
              .filter(producto => producto.descripcion === item.descripcion )
              .map(el => item[lista.proveedor.document] = el.precio_unitario )
              )
            return item
          }) 
          let array_denominaciones = {descripcion: 'Denominación'}
          let array_telefonos = {descripcion: 'Teléfono'}
          let array_calidad = {descripcion: 'Calidad'}
          let array_garantia = {descripcion: 'Garantía'}
          let array_medio_de_pago = {descripcion: 'Medio de pago'}
          let array_envalaje = {descripcion: 'Envalaje'}
          let array_envio = {descripcion: 'Envío'}
          let array_Observaciones = {descripcion: 'Observaciones'}
          let array_tipo_de_cambio = {descripcion: 'Moneda Cambio'}
          let array_condiciones_de_pago = {descripcion: 'Días de crédito' }
          let array_archivo_adjunto = {descripcion: 'Archivo adjunto'}
          let array_id_proveedor = { descripción: 'Enviar whatsapp'}
        
          state.datos.provedores.map(({document, name, phone, key})=> {
            array_denominaciones[document] = name
            array_telefonos[document] = phone            
            array_id_proveedor[document] = `ID:${key}`
          })

          registro_de_propuestas.map(({proveedor_documento, calidad, garantia, medio_de_pago, envalaje, envio, Observaciones, tipo_de_cambio, condiciones_de_pago,archivo_adjunto, key})=>{
            array_calidad[proveedor_documento] = calidad
            array_garantia[proveedor_documento] = garantia
            array_medio_de_pago[proveedor_documento] = medio_de_pago
            array_envalaje[proveedor_documento] = envalaje?'si':'no'
            array_envio[proveedor_documento] = envio?'si':'no'
            array_Observaciones[proveedor_documento] = Observaciones
            array_tipo_de_cambio[proveedor_documento] = tipo_de_cambio
            array_condiciones_de_pago[proveedor_documento] = condiciones_de_pago
            array_archivo_adjunto[proveedor_documento] = archivo_adjunto
          })
          salida.push(
            array_tipo_de_cambio, 
            array_condiciones_de_pago, 
            array_denominaciones, 
            array_telefonos, 
            array_calidad,
            array_garantia, 
            array_medio_de_pago,
            array_envalaje, 
            array_envio,
            array_Observaciones,
            array_archivo_adjunto,
            array_id_proveedor
          )  
          salida = salida.map(item => ({...item, numeracion: salida.indexOf(item) + 1}))
          return salida
          },
          proveedores: state =>  state.datos.provedores.map(proveedor => proveedor.document)
        },
        
  }
  